<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import useAsyncComponentLoader from '@/composables/useAsyncComponentLoader.ts';
  import PageContent from '@/components/customerPage/pageContent/PageContent.vue';
  import type { RoutedCustomerViewComponentProps } from '@/types';

  defineProps<RoutedCustomerViewComponentProps>();

  defineOptions({ name: 'FavouriteAddressesView', inheritAttrs: false });

  const { t } = useI18n();
  const { getAsyncComponentWithLoader } = useAsyncComponentLoader();

  const FavouriteAddressesController = getAsyncComponentWithLoader(() => import('@/components/customerProfilePage/favouriteAddresses/FavouriteAddressesController.vue'));
</script>

<template>
  <PageContent
    narrow-header
    :is-status-box-opened="isStatusBoxOpened"
    :title="t('pages.favouriteAddresses.title')"
    :classes="{content: 'grid-rows-[min-content_min-content]'}"
  >
    <FavouriteAddressesController />
  </PageContent>
</template>
